<template>
  <div class="edu-day-wrap">
    <Header />
    <div class="edu-day-wrap__banner">
      <img src="../../assets/P-2.png" />
    </div>
    <div class="edu-day-wrap__content">
      <div class="edu-day-wrap__content-title">
        <h2>
            第五届5·15全国投资者保护宣传日
        </h2>
      </div>
      <div>
        <h2>心系投资者，携手共行动——拥抱全面注册制改革，保护投资者合法权益</h2>
      </div>
      <div class="edu-day-wrap__content-img">
        <img src="../../assets/eduDetail.png" alt="" srcset="">
      </div>
    </div>
    <Footer />
  </div>
</template>
  
  <script>
import Header from "../header";
import Footer from "../footer";

export default {
  name: "Eduday",
  data() {
    return {};
  },
  methods: {},
  components: {
    Header,
    Footer,
  },
};
</script>
  
  <style scoped lang="scss">
.edu-day-wrap {
  min-height: 100%;
  background: rgba(245, 245, 245, 1);
  padding-top: 6rem;

  &__banner {
    img {
      width: 100%;
      margin-bottom: 0;
    }
  }
  &__content {
    width: 75rem;
    margin: 0 auto;
    padding: 3.13rem 6.26rem;
    padding-bottom: 180px;
    background-color: #fff;
    margin-top: 0.1rem;
    text-align: center;
    color: #323232;
    font-size: 1rem;
    overflow: hidden;
    &-title {
      color: red;
      margin-bottom: 1rem;
    }
    &-img {
        margin-top: 15px;
      img {
        width: 100%;
      }
    }
  }
}
</style>
  


// WEBPACK FOOTER //
// src/components/Eduday/Eduday.vue